import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { phoneNumbersRoute } from 'src/app/app-routing.module';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { PhoneNumberDetailSaveModel } from '../../phone-number-details/models/phone-number-detail-save.model';
import { AddPhoneNumberApiService } from '../services/add-phone-number-api.service';
import * as AddPhoneNumberActions from './add-phone-number.actions';

@Injectable()
export class AddPhoneNumberEffects {
   createPhoneNumber$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddPhoneNumberActions.createPhoneNumber),
         switchMap((action) => {
            const phoneNumberToSave: PhoneNumberDetailSaveModel = {
               ...action.phoneNumber,
               isActive: action.phoneNumber.isActive ?? false,
               isPorted: action.phoneNumber.isPorted ?? false,
            };
            return this.addPhoneNumberApiService.create(phoneNumberToSave).pipe(
               map((executionResult) => {
                  return AddPhoneNumberActions.createPhoneNumberSuccess({
                     _phoneNumber: executionResult.data.phoneNumber.phoneNumber,
                     phoneNumberId: executionResult.data.phoneNumber.phoneNumberId,
                  });
               }),
               catchError((error) => {
                  return of(AddPhoneNumberActions.createPhoneNumberFailure(error));
               })
            );
         })
      );
   });

   createPhoneNumberAndAddAnother$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddPhoneNumberActions.createPhoneNumberAndAddAnother),
         switchMap((action) => {
            const phoneNumberToSave: PhoneNumberDetailSaveModel = {
               ...action.phoneNumber,
               isActive: action.phoneNumber.isActive ?? false,
               isPorted: action.phoneNumber.isPorted ?? false,
            };
            return this.addPhoneNumberApiService.create(phoneNumberToSave).pipe(
               map((executionResult) => {
                  return AddPhoneNumberActions.createPhoneNumberAndAddAnotherSuccess({
                     _phoneNumber: executionResult.data.phoneNumber.phoneNumber,
                     phoneNumberId: executionResult.data.phoneNumber.phoneNumberId,
                     accountId: executionResult.data.phoneNumber.accountId,
                     accountName: action.accountName,
                  });
               }),
               catchError((error) => {
                  return of(AddPhoneNumberActions.createPhoneNumberAndAddAnotherFailure(error));
               })
            );
         })
      );
   });

   createPhoneNumberAndAddAnotherSuccess$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(AddPhoneNumberActions.createPhoneNumberAndAddAnotherSuccess),
            tap((action) => {
               this.snackbar.open(`Phone Number ${action._phoneNumber} Created`);
            })
         );
      },
      { dispatch: false }
   );

   createPhoneNumberSuccess$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(AddPhoneNumberActions.createPhoneNumberSuccess),
            tap((action) => {
               this.dialogService.closeFormComponent();
               this.router.navigate([`/${phoneNumbersRoute}/${action.phoneNumberId}`]);
               this.snackbar.open(`Phone Number ${action._phoneNumber} Created`);
            })
         );
      },
      { dispatch: false }
   );

   constructor(
      private actions$: Actions,
      private addPhoneNumberApiService: AddPhoneNumberApiService,
      private snackbar: MatSnackBar,
      private dialogService: LcsDialogService,
      private router: Router
   ) {}
}
